import KeenSlider from "keen-slider";

let dots;

const navigation = (slider) => {
	dots = document.querySelectorAll("[data-slider-control]");
	dots.forEach((el, i) => (el.dataset.index = i));
	dots[0].dataset.active = true;

	const leftBtn = document.querySelector("[data-dir=left]");
	const rightBtn = document.querySelector("[data-dir=right]");

	leftBtn.addEventListener("click", slider.prev);
	rightBtn.addEventListener("click", slider.next);
	slider.on("slideChanged", updateDots);
};

const updateDots = (e) => {
	dots.forEach((el) => (el.dataset.active = false));
	dots[e.track.details.rel].dataset.active = true;
};

export default function () {
	if (document.querySelector("[data-global-press-carousel]")) {
		new KeenSlider(
			"[data-global-press-carousel]",
			{
				loop: true,
				slides: {
					perView: 1,
				},
				breakpoints: {
					"(min-width: 768px)": {
						slides: {
							perView: 2,
							spacing: 24,
						},
					},
					"(min-width: 992px)": {
						slides: {
							perView: 3,
							spacing: 48,
						},
					},
				},
			},
			[navigation]
		);
	}
}
